import { render, staticRenderFns } from "./data-aside.vue?vue&type=template&id=7788d89c"
import script from "./data-aside.vue?vue&type=script&lang=js"
export * from "./data-aside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports